/* eslint-disable no-underscore-dangle */
const _ = require('lodash');
const AttributeEvaluationResponse = require('./../../AttributeEvaluationResponse/index');
const Formula = require('../../../NumericValues/Formula');
const FormulaEvaluationException = require('./../../../Exceptions/formulaEvaluationException');
const Range = require('../../../NumericValues/Range');

const CollectionAttribute = require('./../index');

function validate(config) {
  if (_.isNil(config)) {
    throw new Error('config must not be null or undefined.');
  }

  if (_.isNil(config.formula)) {
    throw new Error('formula is not defined');
  }

  return true;
}

function createEvaluationContext(attributeDomain) {
  const evaluationContext = {};
  _.forOwn(attributeDomain, (values, key) => {
    if (values.length === 1) {
      [evaluationContext[key.toLowerCase()]] = values;
    }
  });

  return evaluationContext;
}

module.exports = class AttributeConstraintsFormula extends CollectionAttribute {
  /**
   * See parent for details.
   * @param  {String} config.formula A string representing a formulaic expression
   */
  constructor(config) {
    validate(config);
    super(config);

    this._formula = config.formula;
    this._type = CollectionAttribute.Types.formula;

    this._isValid = true;
  }

  get formula() {
    return this._formula;
  }

  /**
   * Formulas only have one value but they do need to be evaluated
   * For our current state, they can be implied if there is an evaluated value
   *
   * @readonly
   */
  canBeImplied() {
    return this.validOptions.length === 1;
  }

  get validOptions() {
    return this._validValue ? [new Range(this._validValue, this._validValue, this._validValue)] : [];
  }

  /**
   * Evaluate the current rule based on the provided attributeSelection.
   *
   * @param  {Object} attributeDomain The attribute selection to evaluate.
   */
  evaluate(attributeDomain) {
    try {
      const evaluationContext = createEvaluationContext(attributeDomain);

      this._validValue = Formula.evaluate(this._formula, evaluationContext);

      return new AttributeEvaluationResponse(this._key, true, this._evaluateState, {
        expression: this._formula,
        value: this._validValue.toString(),
      });
    } catch (err) {
      // Set this to evaluate false so that the rule containing this isn't set to violated. It's not necessarily violated
      // if we just can't evaluate the formula
      this._evaluateState = false;

      return new AttributeEvaluationResponse(
        this._key,
        false,
        this._evaluateState,
        { expression: this._formula },
        new FormulaEvaluationException(err.message),
      );
    }
  }

  /**
   * Check to see if value is valid selection for the formula
   * @param value Selection to check
   * @param attributeSelection Set of selections to evaluate the formula with
   * @returns {boolean} True if selection is valid, else false
   */
  isValidSelection(value, attributeSelection) {
    try {
      const validValue = Formula.evaluate(this._formula, attributeSelection);

      return validValue === Number(value);
    } catch (err) {
      return false;
    }
  }
};
